import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { TextField, Typography } from '@material-ui/core';
import { ErrorMessage, Field } from 'formik';

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '30%'
  },
  errorText: {
    color: 'red',
    fontSize: 12
  }
}));

const SearchTextField = props => {
  const classes = useStyles();
  const { name, label, width,onChange,value } = props;
  return (
    <>
      <Field
        as={TextField}
        className={width ? width : classes.formControl}
        name={name}
        label={label}
        onChange={onChange}
        value={value}
        variant="outlined"
      />
      <Typography className={classes.errorText}>
        <ErrorMessage name={name} />
      </Typography>
    </>
  );
};

export default SearchTextField;
